var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceoreder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 219,
    viewBox: "0 0 264 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.438 7.92053H0V97.4368H136.438V7.92053Z",
    fill: "#CDDDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2574 40.4967H0V44.5665H79.2574V40.4967Z",
    fill: "#AEC5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.438 60.1703H84.5176V64.24H136.438V60.1703Z",
    fill: "#AEC5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5187 7.92053H79.2578V97.4368H84.5187V7.92053Z",
    fill: "#AEC5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5794 0C38.8 0 34.2163 1.81123 30.8367 5.03526C27.4572 8.2593 25.5586 12.632 25.5586 17.1915C25.5586 26.6815 43.5794 43.0152 43.5794 43.0152C43.5794 43.0152 61.5812 26.6815 61.5812 17.1915C61.5837 14.9347 61.1199 12.6996 60.2164 10.614C59.3128 8.52831 57.9872 6.63299 56.3153 5.03638C54.6435 3.43976 52.6581 2.17314 50.4728 1.30896C48.2875 0.444784 45.9451 -1.27431e-06 43.5794 0ZM43.5794 19.1078C42.4443 19.1078 41.3347 18.7866 40.3909 18.185C39.4471 17.5834 38.7115 16.7284 38.2772 15.7279C37.8428 14.7275 37.7291 13.6267 37.9506 12.5646C38.172 11.5026 38.7186 10.527 39.5213 9.76134C40.3239 8.99565 41.3465 8.47419 42.4598 8.26293C43.5731 8.05168 44.727 8.1601 45.7757 8.57449C46.8244 8.98888 47.7207 9.69063 48.3514 10.591C48.982 11.4914 49.3186 12.5499 49.3186 13.6328C49.3186 15.0848 48.7139 16.4774 47.6376 17.5041C46.5613 18.5309 45.1015 19.1078 43.5794 19.1078Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.143 184.836H56.8945V133.28L87.0632 81.7235H145.143V184.836Z",
    fill: "#7AA5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21 46.5558H145.143V184.854H352.21V46.5558Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8945 133.28H109.427V87.235H83.8302L56.8945 133.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.142 171.368H53.6602V187.683H145.142V171.368Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4533 156.767H61.2168V168.812H67.4533V156.767Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.217 156.767H54.9805V168.812H61.217V156.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53 87.235H114.189V133.28H133.53V87.235Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.019 171.368H145.143V187.683H264.019V171.368Z",
    fill: "#7AA5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.812 46.5558H145.143V171.368H156.812V46.5558Z",
    fill: "#CDDDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.122 195.932C136.596 181.458 126.302 167.812 111.129 165.452C95.9569 163.092 81.6519 172.913 79.1782 187.387C76.7045 201.861 86.9989 215.507 102.171 217.867C117.344 220.227 131.649 210.407 134.122 195.932Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.653 196.573C124.477 188.685 120.064 180.107 111.796 177.412C103.527 174.718 94.5344 178.928 91.7099 186.816C88.8854 194.704 93.2987 203.282 101.567 205.977C109.836 208.671 118.828 204.461 121.653 196.573Z",
    fill: "#B4CCEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.652 204.601C114.227 204.601 120.369 198.742 120.369 191.515C120.369 184.289 114.227 178.43 106.652 178.43C99.0766 178.43 92.9355 184.289 92.9355 191.515C92.9355 198.742 99.0766 204.601 106.652 204.601Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.408 131.966H56.8945V133.28H109.408V131.966Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.331 144.047H171.926V146.73H241.331V144.047Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.515 92.6188H122.109V95.3015H191.515V92.6188Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.448 195.476H131.043V198.158H200.448V195.476Z",
    fill: "#0D5EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.985 154.085H204.58V156.767H273.985V154.085Z",
    fill: "#0D5EFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 219,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceoreder);
export default __webpack_public_path__ + "static/media/placeoreder.c5e3fd3eb041ab499ade7bc19b603b59.svg";
export { ForwardRef as ReactComponent };